import React, { useMemo, useState } from 'react';
import { Empty, Input } from 'antd';
import { CardGrid, IntegrationCard } from './IntegrationCard';

/**
 * Category pills + search + responsive card grid. `cards` is `[{ key, category, name, purpose, logoKey, status,
 * updatedAt, note, menu, onOpen }]`; the pills are built from the categories actually present, in first-seen order.
 */
const IntegrationsGrid = ({ cards, children }) => {
    const [category, setCategory] = useState('All');
    const [query, setQuery] = useState('');

    const categories = useMemo(() => ['All', ...new Set(cards.map((c) => c.category))], [cards]);
    const active = categories.includes(category) ? category : 'All';
    const q = query.trim().toLowerCase();
    const shown = cards.filter((c) => (active === 'All' || c.category === active)
        && (!q || [c.name, c.purpose, c.category].join(' ').toLowerCase().includes(q)));

    return (
        <div>
            <div className="int-toolbar">
                <div className="int-pills" role="group" aria-label="Filter by category">
                    {categories.map((c) => (
                        <button key={c} type="button" className={`int-chip${c === active ? ' int-chip-active' : ''}`} aria-pressed={c === active} onClick={() => setCategory(c)}>
                            {c}
                        </button>
                    ))}
                </div>
                <Input
                    className="int-search"
                    aria-label="Search integrations"
                    allowClear
                    placeholder="Search integrations"
                    value={query}
                    onChange={(e) => setQuery(e.target.value)}
                />
            </div>
            {children}
            {cards.length > 0 && shown.length === 0 && <Empty description="No integrations match your filter." />}
            <CardGrid>
                {shown.map(({ key, category: _category, ...card }) => <IntegrationCard key={key} cardKey={card.name} {...card} />)}
            </CardGrid>
        </div>
    );
};

export default IntegrationsGrid;
